<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
        const options = [];
        for(let i = -12;i<=12;i++){
            options.push({ value: i, label: i<0?'UTC'+i:'UTC+'+i });
        }
		return{
			options,
		}
	},
	props:['value'],
}
</script>

